module.exports = __webpack_public_path__ + "img/Close-up_The_Scarab_bioreactor.d5735668.webp";